export const dataHooks = {
  sidePanelContent: 'sidePanel-content',
  sidePanelHeader: 'sidePanel-header',
  sidePanelFooter: 'sidePanel-footer',
  sidePanelHeaderTitle: 'sidePanel-header-title',
  sidePanelHeaderTitleInfoIcon: 'sidePanel-header-title-info-icon',
  sidePanelHeaderSubtitle: 'sidePanel-header-subtitle',
  sidePanelHeaderDivider: 'sidePanel-header-divider',
  sidePanelFooterDivider: 'sidePanel-footer-divider',
  sidePanelHeaderCloseButton: 'sidePanel-header-close-button',
  sidePanelHeaderHelpButton: 'sidePanel-header-help-button',
  sidePanelSectionHeader: 'sidePanel-section-header',
};

export const SKINS = {
  standard: 'standard',
  floating: 'floating',
};
